<mat-toolbar class="mat-elevation-z4">
  <span fxFlex>Guardias</span>
</mat-toolbar>

<div *ngIf="errorMessage" class="error-message">
  <span>{{ errorMessage }}</span>
</div>

<p-table
  [value]="watches"
  responsiveLayout="scroll"
  tableStyleClass="mat-elevation-z4"
  [rows]="100">

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 60px"></th>
      <th>ID</th>
      <th>Fecha</th>
      <th>Abogado/a</th>
      <th>Partido Judicial</th>
      <th>Materia</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-watch>
    <tr>
      <td class="p-text-center">
        <mat-icon
          class="{{ statusColor(watch) }}-text"
          [svgIcon]="statusIcon(watch)"
          [matTooltip]="statusText(watch)">
        </mat-icon>
      </td>
      <td>{{ watch.id }}</td>
      <td>{{ watch.start | date: 'dd/MM/YYYY' }}</td>
      <td>{{ watch.lawyerName | titlecase }}</td>
      <td>{{ watch.judicialDistrict | titlecase }}</td>
      <td>{{ watch.alertType | titlecase }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="empty-state">
        No hay guardias activas en este momento.
      </td>
    </tr>
  </ng-template>
</p-table>
